import React from 'react';
import styles from './grid.module.css'

const Grid = props => {
    const {
      id,
      alignItems,
      children,
      column,
      expanded,
      justify,
      lg,
      md,
      row,
      sm,
      className,
      grow
    } = props;
  
    const isRow = row || !column;
  
    const classes =
      (!isRow ? styles.column : styles.row) +
      // Row styling
      (isRow && expanded ? ` ${styles.expanded}` : "") +
      (justify ? ` ${styles[justify]}` : "") +
      (isRow && alignItems ? ` ${styles["align-" + alignItems]}` : "") +
      (grow ? ` ${styles.grow}` : "") +
      (className ? ` ${className}` : "");

      if (id) {
        return <div id={id} className={classes}>{children}</div>;
      } else {
        return <div className={classes}>{children}</div>;
      }
  };
  
  export default Grid;